import { Typography, Button, Modal } from '@safedns/skydns-ui-react-lib';
import styles from './RebuildAgentDialog.module.scss';

const RebuildAgentDialog = ({ onDialogAction, onCancel }) => {
  return (
    <Modal
      isOpen={true}
      title="Пересобрать агент?"
      onClose={onCancel}
      sx={{ maxWidth: 460 }}
    >
      <div className={styles['dialog-content']}>
        <Typography
          className={styles['description-text']}
          sx={{ paddingBottom: 16 }}
        >
          Будет создан новый агент с новым PIN-кодом.
        </Typography>
        <div className={styles['button-grid']}>
          <Button
            variant="secondary"
            size="small"
            onClick={onCancel}
            className={styles['button-cancel']}
          >
            Отменить
          </Button>
          <Button
            variant="primary"
            size="small"
            onClick={onDialogAction}
            className={styles['button-submit']}
          >
            Пересобрать
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RebuildAgentDialog;
